import React from "react";
import ReactECharts from "echarts-for-react";
import { Box, Typography } from "@mui/material";
import type { EChartsOption } from "echarts";

type Props = {
  option: EChartsOption;
  height?: number | string;
  empty?: boolean;
  emptyText?: string;
  onItemClick?: (params: any) => void;
};

export default function EChartBase({
  option,
  height = 320,
  empty = false,
  emptyText = "No data available",
  onItemClick,
}: Props) {
  if (empty) {
    return (
      <Box
        sx={{
          height,
          border: "1px dashed #D8E0E8",
          borderRadius: 2,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          bgcolor: "#FAFCFE",
        }}
      >
        <Typography variant="body2" color="text.secondary">
          {emptyText}
        </Typography>
      </Box>
    );
  }

  return (
    <ReactECharts
      option={option}
      style={{ height, width: "100%" }}
      notMerge
      lazyUpdate
      onEvents={{
        click: (params: any) => onItemClick?.(params),
      }}
    />
  );
}